import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/auth.service';

interface Contact {
  id: string;
  name: string;
  email: string;
  description: string;
  createdAt: string;
  status: 'OPEN' | 'RESOLVED';
}

export default function ContactList() {
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    loadContacts();
  }, []);

  const loadContacts = async () => {
    try {
      setLoading(true);
      const response = await authService.makeAuthenticatedRequest('/contact');
      if (response.ok) {
        const data = await response.json();
        setContacts(data.items);
      } else {
        setError('Erro ao carregar mensagens');
      }
    } catch (err: any) {
      setError(err.message || 'Erro ao carregar mensagens');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: 32,
        maxWidth: 1400,
        margin: '0 auto',
      }}
    >
      <div style={{ marginBottom: 32 }}>
        <h1 style={{
          fontSize: 32,
          fontWeight: 800,
          color: 'var(--foreground)',
          marginBottom: 8,
          letterSpacing: '-0.5px',
        }}>
          Mensagens de Contato
        </h1>
        <p style={{ color: 'var(--muted-foreground)', fontSize: 15, fontWeight: 500 }}>
          <span style={{
            background: 'var(--accent)',
            color: 'white',
            padding: '4px 12px',
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 600,
            marginRight: 8,
          }}>
            {contacts.length}
          </span>
          mensagem{contacts.length !== 1 ? 's' : ''} recebida{contacts.length !== 1 ? 's' : ''}
        </p>
      </div>

        {error && (
          <div
            style={{
              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
              color: 'white',
              padding: 16,
              borderRadius: 12,
              marginBottom: 28,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              <span>{error}</span>
            </div>
            <button
              onClick={() => setError('')}
              style={{
                background: 'rgba(255, 255, 255, 0.2)',
                border: 'none',
                color: 'white',
                width: 28,
                height: 28,
                borderRadius: '50%',
                cursor: 'pointer',
                fontSize: 18,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}
            >
              ×
            </button>
          </div>
        )}

        {loading ? (
          <div
            style={{
              textAlign: 'center',
              padding: 60,
              color: 'var(--muted-foreground)',
              fontSize: 15,
            }}
          >
            <div style={{
              width: 48,
              height: 48,
              border: '3px solid var(--border)',
              borderTop: '3px solid var(--primary)',
              borderRadius: '50%',
              margin: '0 auto 16px',
              animation: 'spin 1s linear infinite',
            }} />
            Carregando mensagens...
          </div>
        ) : contacts.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: 80,
            color: 'var(--muted-foreground)',
          }}>
            <div style={{
              width: 80,
              height: 80,
              margin: '0 auto 24px',
              background: 'var(--muted)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <p style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
              Nenhuma mensagem recebida
            </p>
            <p style={{ fontSize: 14 }}>
              As mensagens de contato aparecerão aqui
            </p>
          </div>
        ) : (
          <div style={{
            background: 'var(--card)',
            border: '1px solid var(--border)',
            borderRadius: 12,
            overflow: 'hidden',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', cursor: 'pointer' }}>
              <thead>
                <tr
                  style={{
                    background: 'linear-gradient(to bottom, var(--muted), var(--card))',
                    color: 'var(--foreground)',
                    textAlign: 'left',
                  }}
                >
                  <th style={{ padding: '16px 20px', fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Nome</th>
                  <th style={{ padding: '16px 20px', fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.5px' }}>E-mail</th>
                  <th style={{ padding: '16px 20px', fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Mensagem</th>
                  <th style={{ padding: '16px 20px', fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Enviado em</th>
                  <th style={{ padding: '16px 20px', fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {contacts.map((contact, index) => (
                  <tr
                    key={contact.id}
                    onClick={() => navigate(`/dashboard/contacts/${contact.id}`)}
                    style={{
                      background: index % 2 === 0 ? 'transparent' : 'var(--muted)',
                      transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                      borderBottom: index === contacts.length - 1 ? 'none' : '1px solid var(--border)',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'var(--accent)';
                      e.currentTarget.style.transform = 'scale(1.01)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = index % 2 === 0 ? 'transparent' : 'var(--muted)';
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    <td style={{ padding: '16px 20px', fontWeight: 600, fontSize: 14 }}>{contact.name}</td>
                    <td style={{ padding: '16px 20px', fontSize: 14, color: 'var(--muted-foreground)' }}>{contact.email}</td>
                    <td
                      style={{
                        padding: '16px 20px',
                        fontSize: 14,
                        maxWidth: 300,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {contact.description}
                    </td>
                    <td style={{ padding: '16px 20px', fontSize: 14, color: 'var(--muted-foreground)' }}>
                      {new Date(contact.createdAt).toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </td>
                    <td style={{ padding: '16px 20px' }}>
                      <span style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6,
                        padding: '6px 12px',
                        borderRadius: 20,
                        fontSize: 12,
                        fontWeight: 600,
                        background: contact.status === 'OPEN'
                          ? 'rgba(251, 146, 60, 0.1)'
                          : 'rgba(34, 197, 94, 0.1)',
                        color: contact.status === 'OPEN' ? '#ea580c' : '#16a34a',
                        border: `1px solid ${contact.status === 'OPEN' ? 'rgba(251, 146, 60, 0.2)' : 'rgba(34, 197, 94, 0.2)'}`,
                      }}>
                        <span style={{
                          width: 6,
                          height: 6,
                          borderRadius: '50%',
                          background: contact.status === 'OPEN' ? '#ea580c' : '#16a34a',
                        }} />
                        {contact.status === 'OPEN' ? 'Aberto' : 'Resolvido'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
}
